import { getClient } from '@lib/sanity';

export async function fetchKinderopvangLocationsNames(preview = false) {

  return await getClient(preview).fetch(`
    *[ _type == "page" && !(_id in path("drafts.**")) && type == "locatie" && level == 3 && domain == "kinderopvang"] {
      pageTitle,
      locationCode,
      slimioIntakeKey,
      'products': tabs[label != "Onze locatie"][] {
        'productName': label,
        'city': coalesce(
          sectionBox[@._type == 'contactSection'][0].city,
          sectionBox[@._type == 'multiContactSection'][0].products[0].contactDetails.city
        )
      }
    }
  `);
}

export async function fetchLocations(preview = false) {
  return await getClient(preview).fetch(`
    *[ _type == "page" && !(_id in path("drafts.**")) && type == "locatie" && level == 3 && domain == "kinderopvang"] {
      _id,
      pageTitle,
      slug,
      geoLocation {
        lat,
        lng
      },
      locationCode,
      cardImage,
      "sectionBox": select(
        // If tabs exist, use tabs and transform to old sectionBox format
        count(tabs) > 0 => [{
          "_type": "multiContactSection",
          "products": tabs[label != "Onze locatie"][] {
            "productName": select(
              label == "Buitenschoolse opvang" => "BSO",
              label == "Kinderdagverblijf" => "KDV",
              label == "Peuteropvang" => "POV"
            ),
            "contactDetails": coalesce(
              sectionBox[_type == 'contactSection'][0],
              sectionBox[_type == 'multiContactSection'][0].products[0].contactDetails
            ) {
              ...
            }
          }
        }],
      ),
      parentSlug,
      parent -> {
        pageTitle,
        slug
      },
    } | order(lower(pageTitle) asc)
  `);
}

export async function fetchLocationsByCity(city, preview = false) {
  return await getClient(preview).fetch(`
    *[ _type == "page" && !(_id in path("drafts.**")) && type == "locatie" && level == 3 && domain == "kinderopvang" && parentSlug == "${ city }"] {
      _id,
      pageTitle,
      slug,
      geoLocation {
        lat,
        lng
      },
      locationCode,
      cardImage,
      "contactDetails": coalesce(
        locationContact{ address, zipCode, city, postBox },
        (tabs[].sectionBox[])[_type == 'contactSection'][0]{ address, zipCode, city, postBox },
        (tabs[].sectionBox[])[_type == 'multiContactSection'][0].products[0].contactDetails{ address, zipCode, city, postBox }
      ),
     "sectionBox": select(
        // If tabs exist, use tabs and transform to old sectionBox format
        count(tabs) > 0 => [{
          "_type": "multiContactSection",
          "products": tabs[label != "Onze locatie"][] {
            "productName": select(
              label == "Buitenschoolse opvang" => "BSO",
              label == "Kinderdagverblijf" => "KDV",
              label == "Peuteropvang" => "POV"
            ),
            "contactDetails": coalesce(
              sectionBox[_type == 'contactSection'][0],
              sectionBox[_type == 'multiContactSection'][0].products[0].contactDetails
            ) {
              ...
            }
          }
        }],
      ),
      parentSlug,
    } | order(lower(pageTitle) asc)
  `);
}
